import React, {
  FocusEvent,
  RefObject,
} from 'react';
import clsx from 'clsx';
import MaskedTextField from 'core/components/MaskedTextField';

const mask = {
  mask: Number,
  lazy: true,
  overwrite: true,
  scale: 0,
};

const decimalMaskExtension = {
  scale: 3,
  radix: '.',
  min: 0,
};

type Props = {
  id?: string;
  disabled?: boolean;
  value?: number | string | null;
  onChange?: (value: string | number | null) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  className?: string;
  inputProps?: object;
  isDecimal?: boolean;
  maskExtension?: object;
  inputRef?: RefObject<HTMLInputElement>;
  placeholder?: string;
  showErrorText?: boolean;
};

export default function NumberTextField({
  value,
  className,
  onChange,
  onFocus,
  isDecimal = false,
  maskExtension = {},
  showErrorText,
  ...props
}: Props) {
  const finalMask = isDecimal
    ? { ...mask, ...decimalMaskExtension, ...maskExtension }
    : { ...mask, ...maskExtension };
  return (
    <MaskedTextField
      {...props}
      mask={[finalMask]}
      value={value?.toString() ?? ''}
      onAccept={onChange}
      showErrorText={showErrorText}
      className={clsx('populate-input populate-number-input bg-white', className)}
    />
  );
}
